import { useStore } from '@stores';
import { useEffect } from 'react';

export const usePublicInvoice = (id: string | undefined) => {
  const { invoiceStore } = useStore();
  const { invoice, loading } = invoiceStore;

  useEffect(() => {
    id && invoiceStore.getPublicInvoice({ id });
  }, [invoiceStore, id]);

  return { invoice, loading };
};
